import Swiper, { Navigation, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';


// Close Model Slider
const sliderClose = document.querySelectorAll('.hotspot-carousel--close');

sliderClose.forEach((singleClose) => {
  singleClose.addEventListener('click', (e) => {
    const hotspotContainer = singleClose.closest('.model--active');
    if (hotspotContainer.classList.contains('active-model-slider')) {
      hotspotContainer.classList.remove('active-model-slider');
    }
  });
});


const MCLSwiper = initCarousel('.hotspot-carousel__container--MCL', '.swiper-button-next__mcl', '.swiper-button-prev__mcl');
const MMLSwiper = initCarousel('.hotspot-carousel__container--MML', '.swiper-button-next__mml', '.swiper-button-prev__mml');

// MCL - Connect Buttons to Slides.
const MCLHotspots = document.querySelectorAll('.model--E18MCL .hotspot-button');
// Add event listener to hotspot buttons.
MCLHotspots.forEach((hotspot) => {
  hotspot.addEventListener('click', (e) => {
    e.preventDefault();
    const hotspotContainer = hotspot.closest('.model--active');
    if (!hotspotContainer.classList.contains('active-model-slider')) {
      hotspotContainer.classList.add('active-model-slider');
    }
    MCLSwiper.slideTo(hotspot.dataset.slide);
  });
});

// MML - Connect Buttons to Slides
const MMLHotspots = document.querySelectorAll('.model--E18MML .hotspot-button');
// Add event listener to hotspot buttons.
MMLHotspots.forEach((hotspot) => {
  hotspot.addEventListener('click', (e) => {
    e.preventDefault();
    const hotspotContainer = hotspot.closest('.model--active');
    if (!hotspotContainer.classList.contains('active-model-slider')) {
      hotspotContainer.classList.add('active-model-slider');
    }
    MMLSwiper.slideTo(hotspot.dataset.slide);
  });
});

// MCL - Swiper change active hotspot.
MCLSwiper.on('activeIndexChange', (e) => {
  MCLHotspots.forEach((hotspot) => {
    if (MCLSwiper.activeIndex.toString() === hotspot.dataset.slide) {
      hotspot.classList.add('active');
    } else {
      hotspot.classList.remove('active');
    }
  });
});

// MML - Swiper change active hotspot.
MMLSwiper.on('activeIndexChange', (e) => {
  MMLHotspots.forEach((hotspot) => {
    if (MMLSwiper.activeIndex.toString() === hotspot.dataset.slide) {
      hotspot.classList.add('active');
    } else {
      hotspot.classList.remove('active');
    }
  });
});


function initCarousel(carousel, navNext, navPrev) {
  // Carousel.
  const swiper = new Swiper(carousel, {
    modules: [Navigation, EffectFade],
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    loop: false, /* looping messes up the slider IDs and become inconsistent */
    lazy: {
      loadPrevNext: true,
    },
    navigation: {
      nextEl: navNext,
      prevEl: navPrev,
    },
    a11y: true,
    // preventInteractionOnTransition: true, /* keep disabled, messed up MML hotspot parameters in URL */
  });

  return swiper;
}